/**
* Parse comma-separated string to array
*/
export const parseCommaSeparated = (str: string| undefined | null): string[] => {
 return str ? str.split('~').map(s => s.trim()).filter(Boolean) : [];
};